<template>
  <card-block>
    <card-header>
      Список опросников
      <template v-slot:right>
        <router-link :to="{name: 'quiz.create'}" v-if="can('module.quiz.create')">
          Добавить опросник
        </router-link>
      </template>
    </card-header>
    <card-body>
      <spinner-block v-model="progress">

        <div v-if="data && data.data && data.data.length">
          <table class="table table-hover">
            <thead>
            <tr>
              <th class="pr-0" style="width: 1rem;"></th>
              <th>Название</th>
              <th class="d-none d-md-table-cell">Код</th>
              <th class="d-none d-md-table-cell">Код группы</th>
              <th class="text-right"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in data.data" :key="row.id">
              <th class="pr-0">
                <is-lock-badge v-model="row.is_lock"/>
              </th>
              <td class="limit-half_length">
                <router-link :to="{name: 'quiz.detail', params: {id: row.id}}" class="main-link">
                  {{ row.name }}
                </router-link>
              </td>
              <td class="d-none d-md-table-cell limit-third_length">
                {{ row.code }}
              </td>
              <td class="d-none d-md-table-cell limit-third_length">
                {{ row.group_code }}
              </td>
              <td class="text-right">

              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info">Список пуст</div>
      </spinner-block>
      <gui-paginate :data="data" ref="paginate" @change="getList"/>
    </card-body>
  </card-block>
</template>

<script>

import IsLockBadge from "@/components/Badge/IsLockBadge";

export default {
  components: {IsLockBadge},
  data: function () {
    return {
      data: null,
      progress: true,
      filter: {}
    }
  },
  props: {},
  computed: {},
  beforeMount() {
    this.filter = storageLoad('filter_' + this.$route.name, this.filter);
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {

      let v = _.clone(this.filter);
      v.search = '';
      storageSet('filter_' + this.$route.name, v);

      axiosGetValue('/api/admin/quiz/list', {
            page: this.$refs.paginate.currentPage,
            per_page: this.$refs.paginate.perPage,
            filter: this.filter,
          },
          e => this.data = e, e => this.progress = e
      )
    },
  }
}
</script>